import { createContext, useContext } from "react";

/** The calling tab's sidebar, which the tab's frame owns (WA-10): a page may ask to open it, never lay it out. */
export interface PaneSidebar {
  readonly isOpen: boolean;
  readonly open: () => void;
}

export const PaneSidebarContext = createContext<PaneSidebar | null>(null);

/** The sidebar of the tab the calling page renders in; `null` outside a tab. */
export function usePaneSidebar(): PaneSidebar | null {
  return useContext(PaneSidebarContext);
}
